// extracted by mini-css-extract-plugin
export var boxItems = "_cm-1";
export var boxItemsLg = "_cm-2";
export var button = "_cm-7";
export var buttonHoverless = "_cm-9";
export var buttonLg = "_cm-8";
export var filterGroupBox = "_cm-0";
export var icon = "_cm-3";
export var iconSecondary = "_cm-6";
export var iconWrapper = "_cm-4";
export var iconWrapperLg = "_cm-5";
export var truncatedLabel = "_cm-a";